import React, { useEffect, useState } from 'react';
import { slide as Menu } from 'react-burger-menu';
import { NavLink } from 'react-router-dom';
import {
  // FiBarChart,
  FiBarChart2,
  FiHome,
  FiLogOut,
  FiPlusSquare,
  // FiPlusSquare,
  FiShoppingBag,
  FiTrendingUp,
} from 'react-icons/fi';

import { useAuth } from '../../hooks/auth';

import { Container } from './styles';

const NavBar: React.FC = () => {
  const { signOut } = useAuth();
  const [showMinhasLojas, setShowMinhasLojas] = useState(false);

  useEffect(() => {
    const lojas = localStorage.getItem('@MeuPantera:lojas');

    if (lojas) {
      setShowMinhasLojas(true);
    }
  }, []);

  return (
    <Container>
      <Menu pageWrapId="page-wrap">
        <NavLink
          className="menu-item"
          activeClassName="selected"
          to="/dashboard"
        >
          <FiHome />
          Dashboard
        </NavLink>
        {showMinhasLojas && (
          <NavLink
            className="menu-item"
            activeClassName="selected"
            to="/minhas-lojas"
          >
            <FiShoppingBag />
            Minhas Lojas
          </NavLink>
        )}
        <NavLink
          className="menu-item"
          activeClassName="selected"
          to="/relatorios"
        >
          <FiBarChart2 />
          Relatórios
        </NavLink>
        <NavLink
          className="menu-item"
          activeClassName="selected"
          to="/indicadores"
        >
          <FiTrendingUp />
          Indicadores
        </NavLink>
        <NavLink
          className="menu-item"
          activeClassName="selected"
          to="/cadastros"
        >
          <FiPlusSquare />
          Cadastros
        </NavLink>
        <NavLink className="menu-item bordertop" onClick={signOut} to="/">
          <FiLogOut />
          Sair
        </NavLink>
      </Menu>
    </Container>
  );
};

export default NavBar;
